/*
 * This Disclosure is a component used
 * as a big white collpase with the big arrow on the right
 */
import React from "react";

/*, { useEffect, useRef }*/
import { Disclosure } from "@headlessui/react";
import MountOnFirstOpen from "../MountOnFirstOpen/index";
import bigArrow from "@assets/image/icones/BigArrow.svg";
import bigArrowDown from "@assets/image/icones/BigArrowDown.svg";
import SvgPlus from "@assets/image/icones/SvgPlus.svg";

import { DisclosureContentFluid } from "@components/TransitionFluid";

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {React.ReactNode} props.otherObject
 * @param {boolean} props.CustonArrow
 * @property {boolean=} mountOnFirstOpen
 * @param {boolean=} props.withArrowDown
 * @param {string=} props.classArrowDown
 * @returns
 */
function DisclosureActions({
  open,
  otherObject,
  CustonArrow,
  withArrowDown,
  classArrowDown=""
}) {
  return (
    <div className="arh-flex arh-shrink-0 arh-flex-nowrap arh-items-center arh-space-x-8 arh-whitespace-nowrap">
      {otherObject}
      {CustonArrow ? (
        <img
          src={SvgPlus}
          alt="Arrow Plus"
          className={`${open
            ? "arh-rotate-45 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
            : "arh-rotate-custom-0 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
            }`}
        />
      ) : withArrowDown ? (
        <div className={classArrowDown}>
          {open ? (
            <img
              src={bigArrowDown}
              alt="Arrow icon down"
            />
          ) : (
            <img
              src={bigArrow}
              alt="Arrow icon"
            />
          )}
        </div>
      ) : (
        <div className={classArrowDown}>
          <img
            src={bigArrow}
            alt="Arrow icon"
            className={`${open
              ? "arh-rotate-custom-90 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
              : "arh-rotate-custom-0 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
              }`}
          />
        </div>
      )}
    </div>
  );
}

/**
 * @typedef {Object} Props
 * @property {boolean=} elementTitle
 * @property {string=} childrenTitle
 * @property {string} title
 * @property {React.ReactNode=} titleIcon
 * @property {React.ReactNode} children
 * @property {boolean=} defaultOpen
 * @property {boolean=} spaceTitle
 * @property {boolean=} notIcone
 * @property {string=} classSpaceTitle
 * @property {string=} classParent
 * @property {React.MutableRefObject<any>=} innerRef
 * @property {boolean=} withArrowDown
 * @property {string=} classDisclosureButton
 * @property {string=} classPersoIcones
 * @property {boolean=} arhCollapseParamChild
 * @property {boolean=} withReference
 * @property {React.ReactNode=} otherObject
 * @property {string=} syncTitleClass
 * @property {string=} syncTitle
 * @property {boolean=} titleWithTag
 * @property {string=} classTag
 * @property {string=} valueTag
 * @property {boolean=} unmount
 * @property {boolean=} forceOpen
 * @property {boolean=} CustonArrow
 * @property {React.ReactNode=} otherCustonArrow
 * @property {string=} paddingRight
 * @property {(open: boolean) => void=} onToggle
 */

/**
 *
 * @param {Props} props
 * @returns
 */
function BigDisclosure(props) {
  const {
    elementTitle,
    childrenTitle,
    title,
    titleIcon,
    children,
    defaultOpen = false,
    classSpaceTitle,
    notIcone = false,
    classParent = "",
    innerRef,
    withArrowDown,
    classDisclosureButton = "arh-bg-white arh-p-[1.44rem]",
    arhCollapseParamChild = false,
    otherObject = <div></div>,
    CustonArrow = false,
    // otherCustonArrow,
    classPersoIcones,
    syncTitle,
    // key,
    syncTitleClass,
    titleWithTag,
    classTag = "arh-rounded-[3.313rem] arh-bg-[#D3E3F1] arh-px-[1.125rem] arh-py-1 arh-text-center arh-font-poppins arh-font-medium arh-text-[#1A4E63]",
    valueTag = "0",
    unmount = false,
    paddingRight = "", //"arh-px-9"
    onToggle,
    withReference = false,
    mountOnFirstOpen = false,
    // forceOpen = false
  } = props;

  // const btnRef = useRef(null);

  // useEffect(() => {
  //   if (forceOpen) {
  //     const openBtn = btnRef?.current;
  //     console.log(title, openBtn.getAttribute("aria-expanded") !== "true");
  //     if (openBtn && openBtn.getAttribute("aria-expanded") !== "true") {
  //       openBtn.click();
  //     }
  //   }
  // }, [forceOpen]);

  return (
    <div
      className={classParent + " arh-w-full"}
      ref={innerRef}
    >
      <Disclosure
        defaultOpen={defaultOpen}
      // key={key}
      >
        {({ open }) => {
          return (
            <>
              <Disclosure.Button
                as="div"
                className={`arh-flex arh-w-full ${titleWithTag ? "arh-items-center" : "arh-items-start"} arh-justify-between ${classDisclosureButton} arh-cursor-pointer arh-rounded arh-border-0 ${paddingRight} arh-text-left`}
                onClick={() => {
                  if (typeof onToggle === "function") {
                    onToggle(!open);
                  }
                }}
              // ref={btnRef}
              >
                <div>
                  {
                    titleWithTag ? (
                      <h6 className="arh-m-0 arh-flex arh-items-center arh-space-x-3 arh-font-poppins arh-text-sm arh-font-medium arh-text-darkGreyColor desktop-mini:arh-text-[13px]">
                        <span className={classTag}>{valueTag}</span>
                        <span
                          className={
                            classSpaceTitle ? classSpaceTitle : "arh-ml-12"
                          }
                        >
                          {title}
                        </span>
                      </h6>
                    ) : (
                      <div className="arh-flex arh-w-full arh-items-start ">
                        {notIcone ? (
                          ""
                        ) : (
                          <div
                            className={`${classPersoIcones} arh-flex arh-h-[1.5rem] arh-w-[1.5rem] arh-items-center arh-justify-center `}
                          >
                            {titleIcon}
                          </div>
                        )}

                        <div
                          className={
                            classSpaceTitle
                              ? `arh-flex arh-flex-1 arh-flex-col ${classSpaceTitle}`
                              : "arh-ml-5 arh-flex arh-flex-1 arh-flex-col"
                          }
                        >
                          <h6
                            className={` arh-m-0 arh-flex arh-items-center arh-font-poppins arh-text-[0.938rem] arh-font-medium arh-text-darkGreyColor desktop-mini:arh-text-[13px]`}
                          >
                            <span className={"arh-w-full "}>{title}</span>
                            {elementTitle ? childrenTitle : ""}
                          </h6>

                          {syncTitle && (
                            <span
                              className={`arh-mt-1 arh-font-poppins arh-text-xs arh-font-normal  arh-text-[#667085] ${syncTitleClass} `}
                            >
                              {syncTitle}
                            </span>
                          )}
                        </div>
                      </div>
                    )
                  }
                </div>
                <DisclosureActions
                  open={open}
                  otherObject={otherObject}
                  CustonArrow={CustonArrow}
                  withArrowDown={withArrowDown}
                  classArrowDown={withReference ? "arh-mt-[14px]" : "arh-mt-0"}
                />
              </Disclosure.Button>
              <DisclosureContentFluid open={open}>
                <div
                  className={`${arhCollapseParamChild ? "arh-collapse-param-child" : " "}`}
                >
                  <Disclosure.Panel unmount={unmount}>
                    {mountOnFirstOpen ? (
                      <MountOnFirstOpen open={open}>{children}</MountOnFirstOpen>
                    ) : children}
                  </Disclosure.Panel>
                </div>
              </DisclosureContentFluid>
            </>
          );
        }}
      </Disclosure>
    </div>
  );
}

export default BigDisclosure;
